module.exports = __webpack_public_path__ + "static/media/night_home.772e2f45.svg";